export default {
  title: {
    en: 'Upgrade your subscription',
  },
  desc: {
    en: 'Get a monthly supply of the fragrance of your choice for just $14.95/month (free shipping!). Cancel anytime.',
  },
}
